import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useRef, lazy, Suspense, useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import ReturnMethodStep from './return-method/ReturnMethodStep';
import { RETURN_METHOD } from '../constants/general';
import { useFlowStore } from '../stores/flowStore';
import ItemsToReturnSkeleton from './items-to-return/ItemsToReturnSkeleton';
import { useReturnStore } from '../stores/returnStore';
import { getWindow, isFeatureSwitchEnabled } from '../utils/general';
var ReturnOnlineForm = lazy(function () { return import('./ReturnOnlineForm'); });
export var ReturnForm = function () {
    var returnMethod = useReturnStore(function (state) { return state.returnMethod; });
    var returnFlow = useFlowStore(function (state) { return state.returnFlow; });
    var parentDivRef = useRef(null);
    // Scrolling to top of form when moving from the itemsToReturn step (it's big so it leaves you at the bottom)
    useEffect(function () {
        if (parentDivRef.current) {
            parentDivRef.current.scrollIntoView();
        }
    }, [returnFlow.itemsToReturnFinished]);
    var instance = useContext(AppContext).instance;
    var allowSORIS = getWindow() && isFeatureSwitchEnabled(instance, 'allowSORIS');
    var isUPSChecked = returnMethod === RETURN_METHOD.UPS_DROP_OFF;
    var isLORPChecked = returnMethod === RETURN_METHOD.LORP;
    var proceedFLow = returnFlow.returnMethodFinished &&
        (allowSORIS || isUPSChecked || isLORPChecked);
    return (React.createElement("div", { ref: parentDivRef },
        React.createElement(ErrorBoundary, { name: "return-form" },
            React.createElement("div", { className: "sui-mb-4" },
                React.createElement(ErrorBoundary, { name: "return-method" },
                    React.createElement(ReturnMethodStep, null))),
            proceedFLow && (React.createElement(Suspense, { fallback: React.createElement(ItemsToReturnSkeleton, null) },
                React.createElement(ReturnOnlineForm, null))))));
};
